var map = {
	"./ai_img1.png": 94924,
	"./ai_img2.png": 31300,
	"./ai_img3.png": 8170,
	"./ai_img4.png": 90889,
	"./ai_img5.png": 12967,
	"./ai_img6.png": 19333,
	"./ai_img7.png": 36786,
	"./ai_img8.png": 97455,
	"./ai_img9.png": 47546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38975;